import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { verifyEmail } from "../../../api/user.api";

import { errorMsg, success } from "../../../utils/notifications";
const VerifyEmail = () => {
  const { token } = useParams(); // Get the token from URL params
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmailToken = async () => {
      try {
        console.log(token);
        const response = await verifyEmail(token); // Call the API function

        if (response.data.success) {
          // setMessage("Email successfully verified! Redirecting to login...");
          success(
            "Email Verified",
            "You have successfully verified your email."
          );
          setTimeout(() => {
            navigate("/"); // Redirect to login after 2 seconds
          }, 2000);
        } else {
          setMessage("Invalid verification token.");
        }
      } catch (error) {
        errorMsg("Oops", error);
        // setMessage("An error occurred during verification. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    verifyEmailToken();
  }, [token, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h2>{message}</h2>
    </div>
  );
};

export default VerifyEmail;
